import styled, { css } from 'styled-components';

interface HamburguerProps {
  active: boolean;
  menuActive?: boolean;
}

export const ButtonDiv = styled.div`
  margin: 5px 20px;
  @media (max-width: 950px) {
    margin: 5px 10px;
    font-size: 12px;
    height: 50px;
  }
`;

export const Container = styled.div`
  height: 50px;
  background: rgb(106, 75, 255);
  margin: -19px -39px 0px -39px;
  font-family: 'Source Sans Pro';

  @media (max-width: 900px) {
    height: 60px;
  }
  display: flex;
  justify-content: space-between;
  box-shadow: 0 4px 2px -2px gray;

  span {
    display: flex;
    align-items: center;
    font-size: 1rem;
    line-height: 15px;

    text-align: center;
    @media (max-width: 900px) {
      width: auto;
    }

    color: var(--white);

    a {
      font-weight: bold;
      @media (max-width: 900px) {
        font-size: 14px;
      }
    }
  }
`;

export const LogoContainer = styled.div`
  width: 145px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2;

  @media (max-width: 900px) {
    width: 120px;
  }

  img {
    height: 28px;
    margin: 5px 10px;
    @media (max-width: 900px) {
      height: 22px;
      margin: 2px 5px;
    }
  }
`;
